export function fetchForReduxPromiseMiddleware(input: string | URL | globalThis.Request, options?: RequestInit) {
  return fetch(input, {
    ...options,
    headers: {
      "Accept": "application/json",
      "Content-Type": "application/json",
    },
  }).then((response) => {
    if (!response.ok) {
      return Promise.reject(new Error(`HTTP error ${response.status}`));
    }
    return response.json();
  }).then((response) => ({data: response}));
}
